/**
 * 简体中文
 */
export default {
  
  // 菜单路由
  route: {
    dashboard: {
      _name: '控制台',
      workplace: {_name: '工作台'},
      analysis: {_name: '分析页'},
      monitor: {_name: '监控页'}
    },

    frontpage: {
      home: {_name: '首页'},
      test: {_name: '接口调试'},
    },

    system: {
      _name: '商户管理',
      admin: {_name: '管理列表'},
      finance: {_name: '财务列表'},
      user: {_name: '商户列表'},
      acceptor: {_name: '承兑列表'},
      menu: {_name: '菜单管理'},
      tenantAdmin: {_name: '运营列表'},
      tenant: {_name: '运营列表'},
    },

    financemgmt: {
      _name: '财务管理',
    },

    acceptormgmt: {
      _name: '承兑管理',
    },

    resource: {
      _name: '资源管理',
      class: {_name: '收款分组'},
      recolumn: {_name: '收款账号'},
    },

    wallet: {
      _name: '钱包设置',
      walletlist: {_name: '钱包列表'},
      currency: {_name: '货币管理'},
      fiatcurrency: {_name: '法币管理'},
      virtualcurrency: {_name: '虚拟币管理'},
      transmodel: {_name: '交易模型'},
    },

    config: {
      _name: '系统设置',
      dictionary: {_name: '字典管理'},
      website: {_name: '参数配置'},
      role: {_name: '角色管理'},
      errorlog: {_name: '系统维护'},
      countryregion: {_name: '国家地区'},
      banks: {_name: '银行管理'},
      clientSimulator: {_name: '接口调试'},
      shuju: {_name: '数据清理'},
    },

    balance: {
      index: {_name: '商户余额'},
    },

    channel: {
      _name: '通道管理',
      type: {_name: '通道类型'},
      uplist: {_name: '渠道列表'},
      dscolumn: {_name: '通道列表(收)'},
      dfcolumn: {_name: '通道列表(付)'},
      amount: {_name: '预设设定'},
      records: {_name: '预设日志'},
    },

    transaction: {
      _name: '交易管理',
      inorder: {_name: '收款订单'},
      inlist: {_name: '收款确认'},
      outorder: {_name: '出款订单'},
      records: {_name: '余额流水'},
      verifyorder: {_name: '核销订单'},
      errorlog: {_name: '商户API错误'},
      upstreamerrorlog: {_name: '上游API错误'},
    },

    reconciliation: {
      _name: '对账管理',
      bussiness: {_name: '用户账单'},
      uplist: {_name: '上游账单'},
      channel: {_name: '通道账单'},
      shouyi: {_name: '系统收益'},
      bank: {_name: '资源账单'},
      bankrecords: {_name: '收款流水'},
    },

    exception: {
      _name: '异常页面',
      '403': {_name: '403'},
      '404': {_name: '404'},
      '500': {_name: '500'}
    },
    user: {
      _name: '个人设置',
      profile: {_name: '个人资料'},
      message: {_name: '我的消息'}
    },
  },
  // 主框架
  layout: {
    home: '主页',
    header: {
      profile: '个人中心',
      password: '修改密码',
      logout: '退出登录'
    },
    footer: {
      website: '官网',
      document: '文档',
      authorization: '授权',
      copyright: 'Copyright © 2021'
    },
    logout: {
      title: '提示',
      message: '确定要退出登录吗?'
    }
  },
  // 登录界面
  login: {
    title: '海拉系统',
    username: '请输入',
    password: '请输入',
    captcha: '请输入',
    remember: '记住密码',
    forget: '忘记密码',
    login: '登录',
    loading: '登录中',
    ipChecking: '正在校验访问 IP…',
    ipDenied: '当前 IP 无访问权限',
    ipCheckFailed: '无法完成 IP 校验，请检查网络或联系管理员',
    googleAuthenticator: 'Google Authenticator(若绑定)',
  },
  // 通用
  universal:{
    startingtime:"开始时间",
    endtime:"结束时间",
    pleasechoose:"请选择",
    pleaseenter:"请输入",
    recognize: "确认",
    inquire:"查询",
    reset:"重置",
    export:"导出",
    turnon:"开启",
    closure:"关闭",
    yes:"是",
    no:"否",
    unknown: '未知',
    success: '成功',
    retreat: '撤销',
    abnormal: '异常',
    cancel: '取消',
  },
  // 首页
  home:{
    totalbalance:"总余额",
    availablebalance:"可用余额",
    freezebalance:"冻结金额",
    unsettledamount:"未结算余额",
  },
  // 清理数据
  cleandata:{
    selecttime:"选择时间",
    startingtime:"开始时间",
    endtime:"结束时间",
    selectdata:"选择数据",
    choose:"请选择",
    option1:"[ 全部数据 ] | 谨慎选择，删除后无法恢复!!!",
    option2:"[ 收款数据 ] | 谨慎选择，删除后无法恢复!!!",
    option3:"[ 出款数据 ] | 谨慎选择，删除后无法恢复!!!",
    option4:"[ 账变数据 ] | 谨慎选择，删除后无法恢复!!!",
    warnings: "提示：请谨慎删除，操作后无法恢复！",
    recognize: "确认清理",
    confirmTitle: "提示",
    confirmDelete: "确认删除",
  },
  // 系统维护
  maintenance: {
    errorLog: '错误日志',
    paymentLog: '调试日志',
    dataClean: '数据清理',
    logTime: '时间',
    logFile: '日志文件',
    logContent: '日志内容',
    clearLog: '清理错误日志',
    clearPaymentLog: '清理调试日志',
    clearLogConfirm: '确定要清理所有错误日志吗？清理后无法恢复！',
    clearPaymentLogConfirm: '确定要清理所有调试日志吗？清理后无法恢复！',
  },
  // 订单列表
  orderlist:{
    username:"用户名称",
    userorder:"用户订单",
    systemorder:"系统订单",
    transactiontype:"交易类型",
    channelorder:"通道订单",
    tradingstatus:"交易状态",
    transactionaccountchanges:"交易帐变",
    selectionperiod:"选择时间",
  },
  // 头部统计
  statistics:{
    today_success:"[今日成功]:",
    today_receipt:"[今日收款]:",
    unknown_orders:" [未知订单]:",
    unknown_amount:" [未知金额]:",
    service_fee:" [手续费]:",
    order_rate:" [订单费率]:",
  }
}
